/**
 * Dummy IPD prescription — mirrors the real `/get_ipd_prescriptions/` response
 * shape (`{ status, data: [...], is_valid }`) exactly, field for field. Shown
 * on the pharmacy dashboard whenever the real API returns no prescriptions.
 */
export const DEMO_IPD_PRESCRIPTION = {
  id: 1,
  admission_id: 42,
  patient_id: 'PAT-1025',
  provisional_diagnosis: 'Acute gastritis',
  allergies: [
    { name: 'Penicillin', severity: 'Severe', reaction: 'Anaphylaxis' },
  ],
  final_diagnosis: 'Gastritis with dehydration',
  medicines: [
    { name: 'Pantoprazole 40mg', dose: '1 tab', frequency: 'OD', duration: '5 days' },
  ],
  status: 'Sent',
  uhid: 'MNV2026001025',
  name: 'Ritika Sharma',
  email: 'ritika@example.com',
  address_line: 'Baner, Pune',
  phone_no: '9123456781',
  aadhaar_no: '',
  abha_id: '',
  abha_no: '',
  day_of_birth: 14,
  gender: 'F',
  doctor_id: 'ad254901-1880-4646-9924-fc11c0ef19aa',
  doctor_name: 'Tiya Sarakr',
  bed_no: 'GP105',
  room_no: 'Floor 1 - Room 103',
  nurse_id: '',
  nurse_name: '',
  assigned_by: '',
  ipd_flag: 'Yes',
  created_at: '2026-07-13T10:22:41.512+00:00',
  updated_at: '2026-07-13T10:22:41.512+00:00',
};
